// extracted by mini-css-extract-plugin
export default {"dropDownList":"DropdownV2_dropDownList__R5TOf","dropDown":"DropdownV2_dropDown__YMlHu","placeHolder":"DropdownV2_placeHolder__XWRzQ","val":"DropdownV2_val__QxWzr"};